import { render, staticRenderFns } from "./CandidateItem.vue?vue&type=template&id=6cab1a2c&"
import script from "./CandidateItem.vue?vue&type=script&lang=js&"
export * from "./CandidateItem.vue?vue&type=script&lang=js&"
import style0 from "./CandidateItem.vue?vue&type=style&index=0&id=6cab1a2c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports